export default "__VITE_ASSET__7d94717c__"